/**
 * React hook for TanStack Store integration
 */

import { useStore } from "@tanstack/react-store";
import {
	hasCancellationBeenSubmitted,
	type RampsState,
	rampsActions,
	rampsStore,
} from "./ramps-store";

export function useRampsStore<TSelected = RampsState>(
	selector?: (state: RampsState) => TSelected,
) {
	return useStore(rampsStore, selector);
}

// Export types
export type { RampsState };
// Export actions and selectors for easy access
export { hasCancellationBeenSubmitted, rampsActions };
